import { Eye } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Explains why controls on this page are greyed out. Renders only for a
 * read-only account — a disabled button with no reason given reads as a bug.
 */
export function ReadOnlyNotice({ children }) {
  const { isViewer } = useAuth();
  if (!isViewer) return null;

  return (
    <div
      className="flex items-center gap-2 rounded-lg px-3 py-2 text-xs"
      style={{
        border: "1px solid var(--oim-border)",
        backgroundColor: "var(--oim-surface-soft)",
        color: "var(--oim-text-muted)",
      }}
      data-testid="read-only-notice"
    >
      <Eye className="w-3.5 h-3.5 shrink-0" style={{ color: "var(--oim-gold)" }} />
      <span>{children}</span>
    </div>
  );
}
